import React from 'react';
import { Accordion, Form } from 'react-bootstrap';

const PrivilegesCheckboxGroup = ({
  privileges,
  zones,
  onTogglePrivilege,
  onToggleAllZonePrivileges,
}: {
  privileges: any[];
  zones: any[];
  onTogglePrivilege: (privilege_id: number, zone_id: number) => void;
  onToggleAllZonePrivileges: (zone_id: number, assign: boolean) => void;
}) => {
  return (
    <Accordion>
      {zones.map((zone, idx) => {
        const zonePrivileges = privileges.filter((priv) => priv.zone_id === zone.zone_id);
        const allChecked = zonePrivileges.length > 0 && zonePrivileges.every((p) => p.assigned);
        const someChecked = zonePrivileges.some((p) => p.assigned) && !allChecked;

        return (
          <Accordion.Item eventKey={String(idx)} key={zone.zone_id}>
            <Accordion.Header>{zone.name}</Accordion.Header>
            <Accordion.Body
              style={{
                maxHeight: '300px',
                overflowY: 'auto',
                padding: 0,
              }}
            >
              {zonePrivileges.length ? (
                <div>
                  {/* Select All Checkbox */}
                  <div className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom bg-light">
                    <label className="mb-0" style={{ fontWeight: 'bold' }}>
                      Select All
                    </label>
                    <Form.Check
                      type="checkbox"
                      checked={allChecked}
                      ref={(input) => {
                        if (input) input.indeterminate = !allChecked && someChecked;
                      }}
                      onChange={(e) => onToggleAllZonePrivileges(zone.zone_id, e.target.checked)}
                    />
                  </div>

                  {zonePrivileges.map((priv) => {
                    const checkboxId = `priv-${priv.privilege_id}-${zone.zone_id}`;
                    return (
                      <div key={checkboxId} className="d-flex justify-content-between align-items-center px-3 py-2 border-bottom">
                        <label htmlFor={checkboxId} className="mb-0" style={{ cursor: 'pointer', flexGrow: 1 }}>
                          {priv.name}
                        </label>
                        <Form.Check
                          id={checkboxId}
                          type="checkbox"
                          checked={priv.assigned}
                          onChange={() => onTogglePrivilege(priv.privilege_id, zone.zone_id)}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <p className="text-muted m-3">No privileges available for this zone.</p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

export default PrivilegesCheckboxGroup;
